import React from 'react';

export const CsvEditorStyles = () => (
  <style>
    {`
      .missing-row {
        background-color: rgba(255, 152, 0, 0.1) !important;
      }
      .complete-row {
        background-color: rgba(76, 175, 80, 0.05) !important;
      }
      .changed-row {
        border-left: 3px solid #2196f3 !important;
      }
      .missing-row.changed-row {
        background-color: rgba(255, 152, 0, 0.15) !important;
        border-left: 3px solid #2196f3 !important;
      }
      .complete-row.changed-row {
        background-color: rgba(33, 150, 243, 0.1) !important;
        border-left: 3px solid #2196f3 !important;
      }
      .selected-row {
        outline: 2px solid #1976d2 !important;
        outline-offset: -2px;
      }
      .selected-row.missing-row {
        background-color: rgba(255, 152, 0, 0.2) !important;
      }
      .selected-row.complete-row {
        background-color: rgba(76, 175, 80, 0.15) !important;
      }
    `}
  </style>
);
